const DeleteAccount = () => {
  return (
    <div>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScD8fjurQQl1hw_8BLGd8gA728BnCxsVHuWuWpeo2jme1Zz4w/viewform?embedded=true"
        width="100%"
        // height="100v"
        style={{ overflow: "hidden", height: "100vh" }}
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
};

export default DeleteAccount;
